import { useState } from "react";

const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 25, 50];

export const usePersistedPagination = (
  storageKey: string,
  defaultPageSize = 10
) => {
  const [tablePage, setTablePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(() => {
    const stored = localStorage.getItem(storageKey);
    const parsed = stored ? Number(stored) : defaultPageSize;
    return DEFAULT_PAGE_SIZE_OPTIONS.includes(parsed) ? parsed : defaultPageSize;
  });

  const handleRowsPerPageChange = (newRowsPerPage: number) => {
    setRowsPerPage(newRowsPerPage);
    localStorage.setItem(storageKey, String(newRowsPerPage));
    setTablePage(1);
  };

  const resetPage = () => setTablePage(1);

  return {
    tablePage,
    setTablePage,
    rowsPerPage,
    handleRowsPerPageChange,
    resetPage,
    paginationRowsPerPageOptions: DEFAULT_PAGE_SIZE_OPTIONS,
  };
};
